<template>
  <div v-show="showLayout" class="hamburger-menu">
    <input type="checkbox" id="menu-btn-check" />
    <span class="menu-btn-name"></span>
    <label for="menu-btn-check" class="menu-btn"><span></span></label>
    <div class="menu-content">
      <div class="header-nav-02">
        <h2 v-show="isLogin">{{ loginName }}</h2>
        <div class="header-nav-area">
          <ul v-show="isLogin" class="header-nav-list item-01">
            <li class="link">
              <router-link to="/products">ご注文</router-link>
            </li>
            <li class="link"><router-link to="/histories">購入履歴</router-link></li>
            <li class="link" v-show="!isShopping"><router-link to="/results">実績確認</router-link></li>
            <li class="link" v-show="!isShopping"><router-link to="/results/tree">組織図</router-link></li>
            <li class="link"><a href="/web/contents/library/index.html">ライブラリ</a></li>
            <li class="link"><router-link to="/pointhistories">ポイント</router-link></li>
            <li class="link"><router-link to="/shoppingguide">ショッピングガイド</router-link></li>
            <li class="link"><router-link to="/qa">よくあるご質問</router-link></li>
            <li class="link"><router-link to="/settings">設定</router-link></li>
          </ul>
          <ul class="header-nav-list item-02">
              <li class="link"><a href="/law.html">特定商取引法に基づく表記</a></li>
              <li class="link"><a href="/smp.html">ソーシャルメディアポリシー</a></li>
            </ul>
          <div v-show="isLogin" class="text-center mt-5">
            <button @click="logout" type="button" class="btn">
              ログアウト
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Authenticate from "@/modules/Authenticate";
let auth = new Authenticate();

export default {
  computed: {
    isLogin() {
      return this.$store.state.isLogin;
    },
    isShopping() {
      return this.$store.state.isShopping;
    },
    isManager() {
      return this.$store.state.isManager;
    },
    loginName() {
      return this.$store.state.loginName;
    },
    showLayout() {
      return this.$store.state.showLayout;
    },
  },
  methods: {
    scrollToAnchorPoint(refName) {
      const el = this.$refs[refName]
      el.scrollIntoView({ behavior: 'smooth'})
    },
    logout() {
      auth.logout();
    },
  },
};
</script>

<style scoped>
.menu-btn {
  position: fixed;
  top: 0px;
  right: 10px;
  display: flex;
  height: 60px;
  width: 60px;
  justify-content: center;
  align-items: center;
  z-index: 90;
  color: #616161;
  cursor: pointer;
}

.menu-btn-name:before {
  content: "MENU";
  position: fixed;
  top: 40px;
  right: 18px;
  color: #424242;
  transition: 0.2s;
  z-index: 90;
}

.menu-btn span,
.menu-btn span:before,
.menu-btn span:after {
  content: "";
  display: block;
  height: 1px;
  width: 25px;
  border-radius: 3px;
  background-color: #616161;
  position: absolute;
}
.menu-btn span {
  height: 0;
}
.menu-btn span:before {
  bottom: 6px;
}
.menu-btn span:after {
  top: 6px;
}

#menu-btn-check:checked ~ .menu-btn span {
  background-color: rgba(
    255,
    255,
    255,
    0
  ); /*メニューオープン時は真ん中の線を透明にする*/
  transition: 0.2s;
}
#menu-btn-check:checked ~ .menu-btn span::before {
  bottom: 0;
  transform: rotate(45deg);
  transition: 0.2s;
}
#menu-btn-check:checked ~ .menu-btn span::after {
  top: 0;
  transform: rotate(-45deg);
  transition: 0.2s;
}
#menu-btn-check:checked ~ .menu-btn-name:before {
  content: "CLOSE";
  transition: 0.2s;
}

#menu-btn-check {
  display: none;
}

.menu-content {
  width: 400px;
  position: fixed;
  right: 0;
  height: 100%;
  top: 0;
  /*left: 100%;/*leftの値を変更してメニューを画面外へ*/
  visibility: hidden;
  opacity: 0;
  z-index: 80;
  color: #616161;
  background-color: #ffffff;
  transition: all 0.2s; /*アニメーション設定*/
  border-left: 1px solid #eee;
  overflow-x: scroll;
}
#menu-btn-check:checked ~ .menu-content {
  /* left: 0;/*メニューを画面内へ*/
  visibility: visible;
  opacity: 1;
  transition-duration: 0.2s;
}

.header-nav-02 h2 {
  height: 80px;
  margin-bottom: 0px;
  padding: 25px;
  text-align: left;
  font-size: 2rem;
}
.header-nav-list {
  display: -ms-flexbox;
  display: flex;
  -ms-flex-align: center;
  align-items: center;
}
.header-nav-02 .header-nav-area {
  width: 100%;
  height: calc(100% - 75px);
  padding: 0 15px 15px;
}
.header-nav-02 .item-01 .link,
.header-nav-02 .item-02 .link,
.header-nav-02 .item-03 .link {
  margin: 0;
  text-align: left;
}
.header-nav-02 .item-01 .link,
.header-nav-02 .item-02 .link {
  border-bottom: 1px solid #eee;
}
.header-nav-02 .item-01 {
  display: block;
}
.header-nav-02 .item-01 a,
.header-nav-02 .item-02 a {
  padding: 8px 10px;
}
.header-nav-02 .item-02 {
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -ms-flex-pack: justify;
  justify-content: space-between;
  margin-top: 12px;
  font-size: 11px;
}
.header-nav-02 .item-02 .link {
  width: calc(50% - 7px);
}
.header-nav-02 .item-03 {
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  margin-top: 12px;
  font-size: 10px;
}
.header-nav-02 .item-03 .link {
  width: 100%;
}
.header-nav-02 .item-03 .link a {
  padding: 3px 10px;
}
.header-nav-02 .item-04 {
  margin-top: 8px;
}
.header-nav-02 .item-04 .ico {
  width: 38px;
  height: 38px;
}
.header-nav-02 .item-04 .ico a {
  padding: 10px;
}
.header-nav-02 .item-04 .ico img {
  width: 100%;
  height: 100%;
}

.header-nav-area a,
.header-nav-area img,
.header-nav-area span {
  display: block;
}
@media (min-width: 1px) and (max-width: 699px) {
  .menu-content {
    width: 100%;
    left: 0;
  }
}
</style>